import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IDocument } from '../Models/IDocument';
import { ITypedValidationResult } from '../Models/IValidationResult';

class documentService extends BaseApiService {
    public constructor() {
        super('Document/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByDocumentId(documentId: number, personId: number, auth0Id: string): Promise<IDocument> {
        return this.httpClient.get<IDocument>(`GetByDocumentId?documentId=${documentId}&personId=${personId}&auth0Id=${auth0Id}`, documentService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    //returns the document ID or 0
    public async saveDocument(document: IDocument, auth0Id: string) {
        console.log('Saving document');
        //this.httpClient.post<ITypedValidationResult<IDocument>>(`SaveDocument?personId=${personId}auth0Id=${auth0Id}`, document, documentService.config).catch(this.handleError.bind(this));

        try {
            const response = await this.httpClient.post<number>(
                `SaveDocument?&auth0Id=${auth0Id}`,
                document,
                documentService.config
            );
            console.log('document id: ' + response.data);
            return response.data;
        } catch (error) {
            this.handleError(error); // Handle the error
            return 0;
        }
    }

    public base64ToBlob(base64: string, contentType: string = ''): Blob {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

}

export const DocumentService: documentService = new documentService();

export function createDocument(): IDocument {
    return {
        documentId: 0,
        documentTypeId: 0,
        filename: '',
        contentBase64: '',
        modifiedBy: '',
        modifiedDate: ''
    };
}